/** Approximate city centers used to plot agencies. Unknown cities are omitted from the map. */
const CITY_COORDINATES: Record<string, { lat: number; lng: number }> = {
  agadir: { lat: 30.4278, lng: -9.5981 },
  marrakech: { lat: 31.6295, lng: -7.9811 },
  marrakesh: { lat: 31.6295, lng: -7.9811 },
  casablanca: { lat: 33.5731, lng: -7.5898 },
  casa: { lat: 33.5731, lng: -7.5898 },
  rabat: { lat: 34.0209, lng: -6.8416 },
  tanger: { lat: 35.7595, lng: -5.834 },
  tangier: { lat: 35.7595, lng: -5.834 },
  fes: { lat: 34.0181, lng: -5.0078 },
  fez: { lat: 34.0181, lng: -5.0078 },
  meknes: { lat: 33.8935, lng: -5.5473 },
  oujda: { lat: 34.6814, lng: -1.9086 },
  tetouan: { lat: 35.5889, lng: -5.3626 },
  essaouira: { lat: 31.5085, lng: -9.7595 },
  nador: { lat: 35.1681, lng: -2.9335 },
  safi: { lat: 32.2994, lng: -9.2372 },
  eljadida: { lat: 33.2316, lng: -8.5007 },
  'el jadida': { lat: 33.2316, lng: -8.5007 },
  kenitra: { lat: 34.261, lng: -6.5802 },
  ouarzazate: { lat: 30.9335, lng: -6.937 },
  laayoune: { lat: 27.1536, lng: -13.2033 },
  dakhla: { lat: 23.6848, lng: -15.957 },
  taghazout: { lat: 30.545, lng: -9.7107 },
  ifrane: { lat: 33.5228, lng: -5.1106 },
};

export function cityCoordinates(city: string): { lat: number; lng: number } | null {
  const key = city
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
  return CITY_COORDINATES[key] ?? null;
}
